import { MILLISECONDS } from '@/libs/core/src/lib/constants/time';
import { useQuery } from 'react-query';
import { useSandboxClinicalData } from '../../../contexts/sandboxClinicalData.context';
import userService from '../../../services/user.service';
type Props = { type?: string; name?: string };

const query = ({ type, name }: Props) => {
  return async () => {
    return userService.settings({ type, name });
  };
};

const useSettings = ({ type, name }: Props) => {
  const sandbox = useSandboxClinicalData();
  const { data, refetch, isFetching } = useQuery<any[]>(
    ['settings', type ?? null, name ?? null],
    sandbox ? () => [] : query({ type, name }),
    {
      refetchOnWindowFocus: false,
      staleTime: MILLISECONDS.inMinutes(10),
    }
  );

  return {
    data,
    isFetching,
    refetch,
  };
};

export default useSettings;
